import React from 'react';
import { Link } from 'react-router-dom';
export function Tour() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-289">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-290">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-291">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-292">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-293">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-294">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-295">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-296">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-297">
          contact
        </a>
      </header>

      {/* Tour content */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-298">
        <p className="lowercase" data-id="element-299">no upcoming shows</p>
      </section>
    </main>;
}